import React, { useCallback, useState, Fragment, useEffect } from 'react';
import ReactTooltip from "react-tooltip";
import { Rnd } from 'react-rnd';
import { useDispatch, useSelector } from 'react-redux'
import { RndStyle } from '../RndStyle'
import { getPosition, handleSetCurrentEntity } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import update from 'immutability-helper';
import { updateEmptyEntity, updateLocationsListStyle } from 'actions/livefeed'
import ReactResizeDetector from 'react-resize-detector';
import AnimateScrollList from './AnimateScrollList'
import './index.less'

const LocationsList = ({ scaleMode }) => {
    React.useEffect(() => {
        ReactTooltip.rebuild()// componentDidUpdate()
    })
    const [summaryLocationsID, setSummaryLocationsID] = React.useState([])

    const dispatch = useDispatch();
    let { livefeedSlides, editorView, slideCurrentIndex, stepNumberState } = useSelector(state => state.livefeededitor)
    const nodeMap = useSelector(state => state.overviewReducer.nodeMap)
    const { floorplanOptions: { duration }, locationsListStyle, historyEntities, fontFamily } = livefeedSlides[slideCurrentIndex]

    React.useEffect(() => {
        let hasSummaryPage = false;
        let locationsID = []
        for (let i = 0, n = livefeedSlides.length; i < n; i++) {
            if (livefeedSlides[i].slideType === "summary") {
                hasSummaryPage = true;
                locationsID = livefeedSlides[i].floorplanOptions.locationsID
            }
        }
        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
        let refinedLocationsID = locationsID.filter(id => nodeMap[id])

        hasSummaryPage ? setSummaryLocationsID(refinedLocationsID) : setSummaryLocationsID([])

    }, [livefeedSlides, nodeMap])

    let history = historyEntities.slice();
    let currentEntity = history[stepNumberState];

    const setLocationsListPos = useCallback((newPosition) => {
        let { x, y } = newPosition;
        // prevent duplicate dispatch
        if (locationsListStyle.left !== x || locationsListStyle.top !== y) {
            const newPos = update(locationsListStyle, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: "" },
                activeToolbarItems: { [0]: { align: { $set: "" } } }
            });
            dispatch(updateLocationsListStyle(newPos));
        }
    }, [dispatch, locationsListStyle])

    const setLocationsListSize = useCallback((width, newPosition) => {
        let newWidth = width > 734 ? 734 : width; // maximum width 734
        let { x, y } = newPosition
        let align = `${locationsListStyle.left === x ? `${locationsListStyle.activeToolbarItems[0].align}` : ""}` // if x doesn't change, keep toolbar active
        if (locationsListStyle.width !== width || locationsListStyle.left !== newPosition.x) {
            const newSize = update(locationsListStyle, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: align },
                width: { $set: newWidth },
                activeToolbarItems: {
                    [0]: {
                        align: { $set: align }
                    }
                }
            });
            dispatch(updateLocationsListStyle(newSize));
        }
    }, [dispatch, locationsListStyle])


    const enableResizing = {
        bottom: false, bottomLeft: editorView, bottomRight: editorView,
        left: editorView, right: editorView, top: false,
        topLeft: editorView, topRight: editorView
    }
    const handleSetCurrentEntityCb = useCallback(() => {
        handleSetCurrentEntity(currentEntity, locationsListStyle, dispatch)
    }, [currentEntity, dispatch, locationsListStyle])

    const { color, size, textStyle } = locationsListStyle

    const style = {
        fontFamily: fontFamily,
        fontWeight: textStyle.bold ? 'bold' : 'unset',
        fontStyle: textStyle.italic ? 'italic' : 'unset',
        textDecoration: textStyle.underline ? 'underline' : 'unset',
        fontSize: size * (scaleMode ? 0.375 : 1),
        color: color
    }

    let locationsName = []

    if (summaryLocationsID.length > 0) {
        for (let i = 0, n = summaryLocationsID.length; i < n; i++) {
            locationsName.push(nodeMap[summaryLocationsID[i]].info.name)
        }
    }

    const [locationsListWidth, setLocationsListWidth] = useState(null)


    useEffect(() => {
        if (locationsListWidth) {
            if (locationsListWidth < 350) {
                const newCol = update(locationsListStyle, {
                    locationCol: { $set: 12 }
                });
                dispatch(updateLocationsListStyle(newCol));
                dispatch(updateEmptyEntity())

            } else if (locationsListWidth >= 350 && locationsListWidth < 500) {
                const newCol = update(locationsListStyle, {
                    locationCol: { $set: 6 }
                });
                dispatch(updateLocationsListStyle(newCol));
                dispatch(updateEmptyEntity())
            } else {
                const newCol = update(locationsListStyle, {
                    locationCol: { $set: 4 }
                });
                dispatch(updateLocationsListStyle(newCol));
                dispatch(updateEmptyEntity())
            }
        }
    }, [dispatch, locationsListStyle, locationsListWidth])

    const titleTip = summaryLocationsID.length > 0 ?
        `Click and choose toolbar options to change text style 
        <br />Click on the edge and drag to change columns layout` : `No chosen locations, select locations in Summary slide`;

    return (
        <Fragment>
            {editorView && !scaleMode ?
                <Rnd
                    data-tip={`${editorView && titleTip}`}
                    bounds={".livefeed-preview-wrapper"}
                    enableResizing={enableResizing}
                    disableDragging={!editorView}
                    style={{
                        pointerEvents: editorView ? 'all' : 'none',
                        border: !editorView && 'none'
                    }}
                    className={`entity-resizable ${currentEntity.id === 'locationsListStyle' ? 'entity-active' : ''} `}
                    lockAspectRatio={false}
                    resizeHandleWrapperClass={"resizers"}
                    resizeHandleStyles={{
                        topRight: RndStyle.topRight, topLeft: RndStyle.topLeft,
                        left: RndStyle.left, right: RndStyle.right,
                        bottomLeft: RndStyle.bottomLeft, bottomRight: RndStyle.bottomRight
                    }}
                    size={{ width: locationsListStyle.width + 12, height: "auto" }}
                    position={{ x: locationsListStyle.left - 6, y: locationsListStyle.top - 6 }}
                    onClick={() => handleSetCurrentEntityCb()}
                    onDragStart={() => handleSetCurrentEntityCb()}
                    onDragStop={(e, d) => setLocationsListPos(getPosition(d))}
                    onResizeStart={() => handleSetCurrentEntityCb()}
                    onResizeStop={(e, direction, ref, delta, position) =>
                        position.x !== 0 && setLocationsListSize(ref.offsetWidth - 12, getPosition(position))
                    }
                >
                    <ReactResizeDetector handleWidth>
                        {({ width }) => {
                            setLocationsListWidth(width)
                            return (
                                <AnimateScrollList
                                    ulStyle={style}
                                    locationsName={locationsName}
                                    locationCol={locationsListStyle.locationCol}
                                    duration={duration}
                                />
                            )
                        }}
                    </ReactResizeDetector>
                </Rnd>
                :
                <div
                    style={{
                        position: "absolute",
                        width: (locationsListStyle.width + 12) * (scaleMode ? 0.375 : 1),
                        height: "auto",
                        pointerEvents: "none",
                        overflow: "hidden",
                        transform: `translate(${(locationsListStyle.left - 6) * (scaleMode ? 0.375 : 1)}px, ${(locationsListStyle.top - 6) * (scaleMode ? 0.375 : 1)}px)`
                    }}
                    className={`entity-resizable  editor-view_false`}
                >
                    <AnimateScrollList
                        ulStyle={style}
                        locationsName={locationsName}
                        locationCol={locationsListStyle.locationCol}
                        duration={duration}
                    />
                </div>
            }
            <ReactTooltip multiline={true} place="top" type="dark" effect="solid" />


        </Fragment >
    );
}


export default LocationsList


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/LocationsList/index.jsx